<div
  class="edit-field-timecode"
  [formGroup]="fieldParameters.sectionsContainer.formGroup"
>
  <input
    [value]="displayValue"
    [placeholder]="placeholder ? placeholder : 'HH:MM:SS,ff'"
    title="{{placeholder}}"
    [id]="formControlName"
    [name]="formControlName"
    type="text"
    (blur)="onFieldBlur($event)"
    (input)="onValueInput($event)"
    (focus)="onFieldFocus()"
    class="edit-field-timecode__input"
    autocomplete="off"
    [ngClass]="{'content-with-copy': fieldParameters.sectionsContainer.isCopy,
                'errorInputFrame': isInvalid()}"
  >
</div>
